import { render, staticRenderFns } from "./retrievePassword.vue?vue&type=template&id=f583ec1c"
import script from "./retrievePassword.vue?vue&type=script&lang=js"
export * from "./retrievePassword.vue?vue&type=script&lang=js"
import style0 from "./retrievePassword.vue?vue&type=style&index=0&id=f583ec1c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports